import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Instagram } from "lucide-react";

// Honest Instagram follow invitation. The previous version promised daily
// 45-60 s Reels and showed 3 fabricated thumbnails that didn't exist on the
// account — Lionel asked us to drop the mismatch. When real Reels are up,
// swap this component for a Reel-grid version (template kept in git history).
const COPY = {
  pt: {
    overline: "Instagram",
    title: "Me acompanhe no Instagram.",
    body: "Bastidores das aulas, dicas rápidas de pronúncia e a Paris que o turista não vê — direto no feed. Siga e me diga oi.",
    cta: "Seguir @francescomlionel",
    handle: "@francescomlionel",
  },
  en: {
    overline: "Instagram",
    title: "Come say hi on Instagram.",
    body: "Behind-the-scenes of classes, quick pronunciation tips and the Paris tourists don't see — straight to your feed. Follow me and drop a message.",
    cta: "Follow @francescomlionel",
    handle: "@francescomlionel",
  },
  fr: {
    overline: "Instagram",
    title: "Dis-moi bonjour sur Instagram.",
    body: "Les coulisses des cours, de petites astuces de prononciation et le Paris que les touristes ne voient pas — directement dans ton fil. Suis-moi et écris-moi.",
    cta: "Suivre @francescomlionel",
    handle: "@francescomlionel",
  },
};

const ReelsSection = () => {
  const { lang } = useLanguage();
  const t = COPY[lang] || COPY.pt;

  return (
    <section
      id="reels"
      data-testid="reels-section"
      className="bg-[#f4f1ea] py-20 sm:py-28 border-t border-[#e5e3db]"
    >
      <div className="max-w-4xl mx-auto px-6 sm:px-10 lg:px-12 text-center">
        <p className="overline inline-flex items-center gap-2">
          <Instagram className="h-3.5 w-3.5 text-[#d9381e]" strokeWidth={2} />
          {t.overline}
        </p>
        <h2
          data-testid="reels-title"
          className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1]"
        >
          {t.title}
        </h2>
        <p className="mt-5 text-base sm:text-lg text-[#3a3a3a] leading-relaxed mx-auto max-w-xl">
          {t.body}
        </p>
        <div className="mt-10 inline-flex flex-col sm:flex-row items-center gap-3">
          <a
            href="https://instagram.com/francescomlionel"
            target="_blank"
            rel="noopener"
            data-testid="reels-follow-cta"
            className="inline-flex items-center gap-2 rounded-full bg-[#1e2a5a] px-6 py-3 text-sm font-semibold text-[#f4f1ea] transition-colors hover:bg-[#d9381e]"
          >
            <Instagram className="h-4 w-4" strokeWidth={2} />
            {t.cta}
          </a>
          <a
            href="https://instagram.com/francescomlionel"
            target="_blank"
            rel="noopener"
            data-testid="reels-handle-link"
            className="text-sm text-[#5c5c5c] hover:text-[#d9381e] transition-colors"
          >
            {t.handle}
          </a>
        </div>
      </div>
    </section>
  );
};

export default ReelsSection;
